export const PayRetailersDepositBanks = [
    { value: '001', label: 'Banco do Brasil S.A.' },
    { value: '341', label: 'Banco Itaú S.A.' },
    { value: '033', label: 'Banco Santander (Brasil) S.A.' },
    { value: '237', label: 'Banco Bradesco S.A.' },
    { value: '237', label: 'Next Tecnologia e Serviços Digitais' },
    { value: '104', label: 'Caixa Econômica Federal' },
    { value: '422', label: 'Banco Safra S.A.' },
    { value: '748', label: 'Banco Cooperativo Sicredi S.A.' },
    { value: '041', label: 'Banco do Estado do Rio Grande do Sul S.A. BANRISUL' },
    { value: '208', label: 'BANCO BTG PACTUAL S.A.' },
    { value: '655', label: 'Neon Pagamentos' },
    { value: '077', label: 'Banco Inter S.A.' },
    { value: '121', label: 'Banco Agibank S.A.' },
    { value: '212', label: 'Banco Original S.A.' },
    { value: '260', label: 'Nubank' },
    { value: '336', label: 'Banco C6 S.A.' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
